
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Check, Trash } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Notification } from "@/context/NotificationContext";

interface NotificationItemProps {
  notification: Notification;
  onMarkAsRead: (id: string) => void;
  onDelete: (id: string) => void;
}

const NotificationItem = ({ 
  notification, 
  onMarkAsRead, 
  onDelete 
}: NotificationItemProps) => {
  // Format timestamp for display
  const formatTime = (date: Date) => {
    const now = new Date();
    const diffInMinutes = Math.round((now.getTime() - date.getTime()) / (1000 * 60));
    
    if (diffInMinutes < 1) return "Just now";
    if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
    
    const hours = Math.floor(diffInMinutes / 60);
    if (hours < 24) return `${hours} hr ago`;
    
    return date.toLocaleDateString();
  };

  return (
    <Card 
      className={notification.read ? "opacity-75" : "border-primary border-l-4"}
    >
      <CardHeader className="pb-2">
        <div className="flex justify-between items-start">
          <CardTitle className={`text-lg ${!notification.read ? "font-bold" : ""}`}>
            {notification.title}
          </CardTitle>
          <span className="text-xs text-muted-foreground">
            {formatTime(notification.timestamp)}
          </span>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm mb-4">{notification.body}</p>
        <div className="flex justify-end gap-2">
          {!notification.read && (
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => onMarkAsRead(notification.id)}
            >
              <Check className="h-4 w-4 mr-1" />
              Mark as read
            </Button>
          )}
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => onDelete(notification.id)}
          >
            <Trash className="h-4 w-4 mr-1" />
            Delete
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationItem;
